import { render, staticRenderFns } from "./MainForm.vue?vue&type=template&id=0e8880aa&scoped=true&"
import script from "./MainForm.vue?vue&type=script&lang=js&"
export * from "./MainForm.vue?vue&type=script&lang=js&"
import style0 from "./MainForm.vue?vue&type=style&index=0&id=0e8880aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8880aa",
  null
  
)

export default component.exports